<template>
    <div class="page--crud">
        <div>
            <h3 class="title">CAIXA - FECHAMENTO DIÁRIO</h3>
            <app-cashier-balancing-filter ref="filter" :loading="loading" @clean-selection="selectedItems = []" @search="search($event)"></app-cashier-balancing-filter>
            <app-grid ref="grid" v-model="selectedItems" :columns="columns" :loadingMessage="isBlingLoading ? 'Salvando pedido(s) no Bling...' : undefined" :rows="rows" :total="totalItems" :loading="loading">
                <div class="summary" style="display: flex; justify-content: space-between; align-items: center">
                    <div style="display: flex;">
                        <div class="summary__item">
                            <span>Itens da lista</span>
                            <h3>{{ totalItems }}</h3>
                        </div>
                        <div class="summary__item">
                            <span>Saldo acumulado</span>
                            <h3>{{ utils.formatMoney(totalAmount,2,'R$ ','.',',') }}</h3>
                        </div>
                    </div>
                    <div>
                        <app-pagination :currentPage="currentPage" :totalPages="getTotalPages" @pagechanged="onPageChange"></app-pagination>
                    </div>
                    <div style="display: flex">
                        <div class="summary__item border-left">
                            <span>Selecionados</span>
                            <h3>{{ selectedItems.length }}</h3>
                        </div>
                        <div class="summary__item" style="flex-direction: row; align-items: flex-start">
                            <span style="margin-right: 10px;">Valor</span>
                            <h3 style="color: var(--font-color--8); font-weight: 400; font-size: 28px; align-self: center;">{{ utils.formatMoney(selectedItemsTotalAmount, 2,'R$ ','.',',') }}</h3>
                        </div>
                    </div>
                </div>
                <template slot="actions" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="edit-row" @click.stop="recover(slotProps.row.requestId)">
                        <icon-edit></icon-edit>
                    </a>
                </template>
                <template slot="received" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="column-received" :class="{active: slotProps.row.payload.received}" style="width: 32px">
                        <fa icon="check" size="sm" />
                    </a>
                </template>
                <template slot="paid" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="column-received" :class="{active: slotProps.row.payload.paid}" style="width: 32px">
                        <fa icon="check" size="sm" />
                    </a>
                </template>
                <template slot="checked" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="column-received" :class="{active: slotProps.row.payload.checked}" style="width: 32px">
                        <fa icon="check" size="sm" />
                    </a>
                </template>
                <template slot="bling" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="column-received" :class="{active: slotProps.row.payload.bling}" style="width: 32px">
                        <fa icon="check" size="sm" />
                    </a>
                </template>
                <template slot="actions" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="edit-row" @click.stop="recover(slotProps.row.requestId)">
                        <icon-edit></icon-edit>
                    </a>
                </template>
            </app-grid>

            <div class="footer">
                <div class="left-side" style="padding-left: 0;">
                    <img :src="logoSrc" style="margin-left: 0" />
                </div>
                <span class="push-both-sides"></span>
                <div class="right-side" v-if="actionsSelectItems.length >= 1">
                    <div class="group">
                        <span>Com selecionados:</span>
                        <app-select v-model="form.action" :items="actionsSelectItems" :popoverProps="{placement:'top-start', horizontalOffset: -15}" title="Ação">
                            <a href="javascript:void(0)" v-if="!form.action">-- Selecione --</a>
                            <a href="javascript:void(0)" v-else>{{ _.find(actionsSelectItems, {value: form.action}).text }}</a>
                            <template slot="section" slot-scope="sectionProps">
                                <h3 style="text-align: left;">{{ sectionProps.text }}</h3>
                            </template>
                            <template slot="item" slot-scope="itemProps">
                                <span>{{itemProps.text }}</span>
                            </template>
                        </app-select>
                    </div>
                    <div class="group">
                        <span>No horário:</span>
                        <app-datetime-selector class="input--borderless datetime-selector" v-model="form.markDatetime" :config="datetimeSelectorConfig" placeholder="HORÁRIO ATUAL"></app-datetime-selector>
                        <a href="javascript:void(0)" v-if="form.markDatetime" @click="form.markDatetime = null"><icon-remove></icon-remove></a>
                    </div>
                    <a class="btn btn--primary" @click="submit()">Confirmar</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapState, mapActions } from 'vuex';

    import utils from '../../../../utils/index';
    import moment from 'moment';
    import _ from 'lodash';
    import shortid from 'shortid'

    import Request from '../../../../vuex/models/Request'

    import CashierBalancingAPI from '../../../../api/cashier-balancing'
    import AddonsAPI from '../../../../api/addons/addons'
    import BlingAPI from '../../../../api/addons/bling-integration'
    import RequestAPI from '../../../../api/requests'
    import CashierBalancingFilter from './CashierBalancingFilter.vue'
    import { GridCore } from '../../../../components/Utilities/Grid/index'
    import { Portuguese } from 'flatpickr/dist/l10n/pt'
    import PaginationComponent from '../../../../components/Utilities/Pagination.vue'

    export default {
        components: {
            'app-cashier-balancing-filter': CashierBalancingFilter,
            'app-grid': GridCore,
            'app-pagination': PaginationComponent
        },
        beforeRouteEnter(to, from, next) {
            next(vm => { 
                next(vm.VXORM.CompanyUser.hasPermission(vm.user.id, 'cashier-balancing', 'view') ? 
                    true : 
                    from.path)
            })
        },
        data(){
            return {
                logoSrc: require('../../../../assets/imgs/logo-2018.png'),
                companyHasBling: false,
                filterData: [],
                currentPage: 1,
                offset: 0,
                limit: 50,
                totalItems: 0,
                totalAmount: 0,
                selectedItems: [],
                rows: [],
                originalRows: [],
                columns: [
                    {
                        text: 'Editar',
                        name: 'actions',
                        style: {
                            'justify-content': 'center'
                        },
                        width: 60
                    },
                    {
                        text: 'Nº',
                        name: 'id',
                        width: 80,
                        style: {
                            'justify-content': 'center'
                        },
                    },
                    {
                        text: 'Endereço',
                        name: 'contactAddress',
                        width: 290
                    },
                    {
                        text: 'Nome',
                        name: 'name',
                        width: 170
                    },
                    {
                        text: 'Data/Entrega',
                        name: 'deliveryDate',
                        width: 120
                    },
                    // {
                    //     text: 'Grupo',
                    //     name: 'contactGroup',
                    // },
                    {
                        text: 'Pagamento',
                        name: 'paymentMethod',
                        width: 170
                    },
                    {
                        text: 'Valor',
                        name: 'amount',
                        width: 120
                    },
                    {
                        text: 'Status',
                        name: 'status',
                        width: 120
                    },
                    {
                        text: 'Recebido',
                        name: 'received',
                        style: { 'justify-content': 'center' },
                        width: 96
                    },
                    {
                        text: 'Pago',
                        name: 'paid',
                        style: {
                            'justify-content': 'center'
                        },
                        width: 96
                    },
                    {
                        text: 'Conferido',
                        name: 'checked',
                        style: { 'justify-content': 'center' },
                        width: 96
                    },
                ],
                filterForm: {
                    deliveryDate: [[]],
                    deliveryDateToSend: [[]],
                    clientGroup: [],
                    paymentMethod: [],
                    responsibleUser: [],
                    status: [],
                    search: ''
                },
                form: {
                    account: null,
                    action: 'received',
                    markDatetime: null,
                    deliveryDate: [[]],
                    deliveryDateToSend: [[]],
                    clientGroup: [],
                    paymentMethod: [],
                    responsibleUser: [],
                    status: []
                },
                loading: true,
                isBlingLoading: false,
                datetimeSelectorConfig: {
                    altInput: true,
                    altFormat: 'd/m/Y H:i:S',
                    dateFormat: 'Z',
                    locale: Portuguese,
                    time_24hr: true,
                    enableTime: true
                }
            }
        },
        computed: {
            ...mapState('auth',['company', 'user']),
            ...mapState('data/users',['users']),
            ...mapState('data/accounts',['accounts']),
            ...mapState('data/client-groups',['clientGroups']),
            ...mapState('data/payment-methods',['paymentMethods']),
            ...mapState('data/request-status',['requestStatusList']),
            ...mapGetters('data/request-status',['requestStatusListSelectItems']),
            selectedItemsTotalAmount(){
                const vm = this
                return _.sumBy(vm.selectedItems, (selectedItem) => {
                    return parseFloat(selectedItem.payload.amount)
                })
            },
            accountsSelectItems(){
                return _.map(this.accounts, (account) => {
                    return {
                        value: account.id,
                        text: account.name
                    }
                })
            },
            actionsSelectItems(){
                return [
                    {
                        text: 'Marcar como recebido',
                        value: 'received'
                    },
                    {
                        text: 'Marcar como pago',
                        value: 'paid'
                    },
                    {
                        text: 'Marcar como conferido',
                        value: 'checked'
                    },
                    {
                        text: 'Integrar com o Bling',
                        value: 'bling'
                    }
                ].filter(selectAction => {
                    if(selectAction.value == 'received')
                        return this.permission.received
                    else if(selectAction.value == 'paid')
                        return this.permission.paid
                    else if(selectAction.value == 'checked')
                        return this.permission.checked
                    else if(selectAction.value == 'bling')
                        return this.companyHasBling
                    else return false
                })

            },
            getTotalPages() {
                return this.totalItems <= this.limit ? 
                    1 : 
                    (!Number.isInteger(this.totalItems / this.limit) ?
                        Math.trunc(this.totalItems / this.limit) : 
                        (this.totalItems / this.limit) - 1) + 1
            },
            permission() {
                return {
                    received: this.VXORM.CompanyUser.hasPermission(this.user.id, 'cashier-balancing', 'receive'), 
                    paid: this.VXORM.CompanyUser.hasPermission(this.user.id, 'cashier-balancing', 'pay'),
                    checked: this.VXORM.CompanyUser.hasPermission(this.user.id, 'cashier-balancing', 'check')
                }
            }
        },
        methods: {
            ...mapActions('draft/request',['runRequestRecoverance']),
            ...mapActions('toast',['showToast', 'showError']),
            getStatus(status){
                switch(status){
                    case 'sent':
                        return 'Enviado'
                    case "pending":
                        return "Pendente"
                    case "in-displacement":
                        return "Em deslocamento"
                    case "canceled":
                        return "Cancelado"
                    case "finished":
                        return "Finalizado"
                    case 'removed':
                        return 'Removido'
                    default:
                        return "---"
                }
            },
            async recover(requestId){
                const vm = this
                try {
                    const request = await RequestAPI.getOne(requestId)
                    console.log(request.data)

                    const requestDenormalized = this.VXORM.STATE_Request.denormalizeRequest(request.data, request.data.status, false)
                    let STATE_request = this.VXORM.STATE_Request.query().where('requestId', requestId).first()

                    if(!STATE_request) {
                        const { STATE_requests } = await this.VXORM.STATE_Request.insert({ data: requestDenormalized })
                        STATE_request = STATE_requests[0]
                    }
                    STATE_request.openWindow(this)

                    STATE_request.$update({
                        where: STATE_request.id,
                        data: {
                            activeTab: 'order'
                        }
                    })
                }
                catch(err){
                    console.log("Error occurred", err)
                }
                /*this.runRequestRecoverance({ requestId, companyId: this.company.id })*/
            },
            search({ filterData = {}, params = {} } = {}){
                const vm = this
                this.loading = true
                this.filterData = filterData

                this.currentPage = 1
                this.offset = 0

                const requestParams = {
                    offset: vm.offset,
                    limit: vm.limit,
                    date: this.filterData.deliveryDateToSend,
                    responsibleUser: this.filterData.responsibleUser,
                    status: this.filterData.status,
                    paymentMethodIds: this.filterData.paymentMethod,
                    search: this.filterData.search
                }
                this.updateFilter(requestParams)
            },
            async submit(){
                try {
                    const vm = this
                    if(!vm.form.action){
                        vm.showToast({
                            type: 'error',
                            message: "Você deve selecionar uma ação!"
                        })
                        return
                    }
                    if(!vm.selectedItems.length){
                        vm.showToast({
                            type: 'error',
                            message: "Você não selecionou nenhum item!"
                        })
                        return
                    }
                    
                    if(vm.form.action === 'paid'){
                        if(!this.permission.paid) {
                            this.showError('Você não tem permissão para fazer essa operação.')
                            return
                        }

                        CashierBalancingAPI.markAs({
                            paidDatetime: vm.form.markDatetime,
                            requestOrderPaymentIds: _.map(_.filter(vm.selectedItems, (selectedItem) => {
                                return selectedItem
                            }), (selectedItem) => {
                                return selectedItem.id
                            })
                        }, 'paid').then(() => {
                            vm.selectedItems = []
                            vm.$refs.filter.apply()
                        })
                    }
                    else if(vm.form.action === 'received') {
                        if(!this.permission.received) {
                            this.showError('Você não tem permissão para fazer essa operação.')
                            return
                        }

                        CashierBalancingAPI.markAs({
                            receivedDatetime: vm.form.markDatetime,
                            requestOrderPaymentIds: _.map(_.filter(vm.selectedItems, (selectedItem) => {
                                return selectedItem
                            }), (selectedItem) => {
                                return selectedItem.id
                            })
                        }, 'received').then(() => {
                            vm.selectedItems = []
                            vm.$refs.filter.apply()
                        })
                    } 
                    else if(vm.form.action === 'checked') {
                        if(!this.permission.checked) {
                            this.showError('Você não tem permissão para fazer essa operação.')
                            return
                        }

                        CashierBalancingAPI.markAs({
                            checkedDatetime: vm.form.markDatetime,
                            requestOrderPaymentIds: _.map(_.filter(vm.selectedItems, (selectedItem) => {
                                return selectedItem
                            }), (selectedItem) => {
                                return selectedItem.id
                            })
                        }, 'checked').then(() => {
                            vm.selectedItems = []
                            vm.$refs.filter.apply()
                        })
                    } else if(vm.form.action == 'bling') {
                        let requestOrders = []
                        this.isBlingLoading = true
                        this.loading = true
                        
                        _.forEach(vm.selectedItems, (item) => {
                            _.forEach(vm.originalRows, (order) => {
                                const { request } = order.requestOrder

                                if (request.id == item.requestId) {
                                    if (_.has(request.addons, 'bling.isSynced') && request.addons.bling.isSynced) {
                                        throw new Error("Item selecionado ja conciliado com o Bling")
                                    } else {
                                        requestOrders.push(order.requestOrderId)
                                    }
                                }
                            })
                        })

                        await BlingAPI.storeOrders({
                            requests: _.uniq(requestOrders),
                            date: this.form.markDatetime || new Date()
                        }).then(() => {
                            this.isBlingLoading = false
                            this.loading = false

                            this.showToast({
                                type: "success",
                                message: "Pedidos salvos com sucesso no Bling"
                            })

                            vm.selectedItems = []
                            vm.$refs.filter.apply()
                        })
                        .catch(() => {
                            this.isBlingLoading = false
                            this.loading = false

                            this.showError("Houve um erro ao salvar os pedidos no Bling")
                        })
                    }
                } catch (error) {
                    this.showError(error.message)
                }   
            },
            onPageChange(page) {
                this.currentPage = page
                this.offset = parseInt(`${page-1}0`)
                let requestParams = {
                    limit: this.limit,
                    offset: this.offset * 5,
                    date: this.filterData.deliveryDateToSend,
                    responsibleUser: this.filterData.responsibleUser,
                    status: this.filterData.status,
                    search: this.filterData.search
                }
                this.updateFilter(requestParams)
            },
            getColumnValues(row, vm) {
                let columns = [
                    {
                        column: 'id',
                        text: row.requestOrder.request.code,
                        style: {
                            'justify-content': 'center'
                        }
                    },
                    {
                        column: 'contactAddress',
                        text(){
                            const hasContactAddress = row.requestOrder.request && row.requestOrder.request.requestContact && row.requestOrder.request.requestContact.contactAddress
                            let contactAddress
                            if(hasContactAddress){
                                contactAddress = _.get(row,'requestOrder.request.requestContact.contactAddress')
                                contactAddress = contactAddress.address.name + ', ' + ((contactAddress.number) ? contactAddress.number : 'SN')
                            }
                            else {
                                contactAddress = '---'
                            }
                            return contactAddress
                        },
                        showTitle: true
                    },
                    {
                        column: 'name',
                        text: _.get(row,'requestOrder.request.requestContact.contact.name', '---'),
                        showTitle: true
                    },
                    // {
                    //     column: 'contactGroup',
                    //     text: _.get(row,'request.requestContact.contact.contactGroup.name', '---')
                    // },
                    {
                        column: 'deliveryDate',
                        text: row.requestOrder.request.deliveryDate ? moment(row.requestOrder.request.deliveryDate).local().format("DD/MM HH:mm") : '---',
                    },
                    {
                        column: 'paymentMethod',
                        text() {
                            return vm.VXORM.PaymentMethod.query().find(row.paymentMethodId).name
                        }
                    },
                    {
                        column: 'amount',
                        text: utils.formatMoney(row.amount, 2,'R$ ','.',','),
                    },
                    {
                        column: 'status',
                        text: this.getStatus(row.requestOrder.request.status),
                    },
                    
                    {
                        column: 'received',
                        html: true,
                        style: {
                            'justify-content': 'center'
                        }
                    },
                    {
                        column: 'paid',
                        html: true,
                        style: {
                            'justify-content': 'center'
                        }
                    },
                    {
                        column: 'checked',
                        html: true,
                        style: {
                            'justify-content': 'center'
                        }
                    },
                    {
                        column: 'actions',
                        html: true,
                        style: {
                            'justify-content': 'center'
                        }
                    }
                ]

                if(this.companyHasBling) {
                    columns.push({
                        column: 'bling',
                        html: true,
                        style: {
                            'justify-content': 'center'
                        }
                    })
                }

                return columns
            },
            updateFilter(requestParams) {
                const vm = this

                this.loading = true
                CashierBalancingAPI.getList(requestParams).then(({data}) => {
                    console.log(data)
                    vm.originalRows = data.rows
                    vm.rows = _.map(data.rows, vm.upsertRow)
                    this.totalItems = data.count
                    this.totalAmount = data.totalAmount
                    this.loading = false
                })
            },
            upsertRow(row){
                const vm = this
                return {
                    id: row.id,
                    requestId: row.requestOrder.request.id,
                    columns: this.getColumnValues(row, vm),
                    payload: {
                        requestId: row.requestId,
                        amount: row.amount,
                        received: row.received,
                        paid: row.paid,
                        checked: row.checked,
                        bling: _.has(row.requestOrder.request.addons, 'bling.isSynced') 
                            ? row.requestOrder.request.addons.bling.isSynced : false
                    }
                }
            },
            async handleBlingDependency() {
                this.companyHasBling = (await AddonsAPI.getAddonsByCompany(this.company.id).then((res) => {
                    return res.filter(addon => addon.alias == "bling")
                })).length > 0

                if(this.companyHasBling) {
                    this.columns.splice(1, 0, 
                        {
                            text: 'Bling',
                            name: 'bling',
                            style: {
                                'justify-content': 'center'
                            },
                            width: 60
                        }
                    )
                }
            }
        },
        async mounted(){
            this.search()
            this.handleBlingDependency()
            /* this.$bus.$on("saveRequest", () => {
                this.onPageChange(this.currentPage)
            }) */
        }
    }
</script>

<style lang="scss">
    .page--crud {
        display: flex;
        width: 100%;
        justify-content: center;
        background-color: var(--bg-color--7);

        a.column-received {
            color: var(--font-color);
            &.active {
                color: var(--font-color--primary);
            }
            background-color: transparent;
        }

        a.edit-row {
            padding: 0 5px;
        }

        a.edit-row .colorizable {
            fill: var(--font-color)
        }

        a.edit-row:hover .colorizable {
            fill: var(--font-color--primary)
        }

        /* title */

        h3.title {
            font-size: 16px;
            text-transform: uppercase;
            color: var(--font-color--7)
        }

        /* filter */

        ul.filter-menu {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            padding-bottom: 20px;
        }
        ul.filter-menu li {
            margin: 0 5px;
            position: relative;
        }
        ul.filter-menu >>> li.datetime-selector input {
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
            overflow: hidden;
            z-index: -1;
        }
        ul.filter-menu li a {
            height: 32px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            color: var(--font-color--7)
        }
        ul.filter-menu li a.right-padding {
            padding-right: 30px;
        }
        ul.filter-menu li a.clear-filter {
            position: absolute;
            top: 10px;
            right: 10px;
        }
        ul.filter-menu li a .primary {
            color: var(--font-color--primary);
            font-weight: 600;
        }
        ul.filter-menu li a .dot-separator.primary {
            background-color: var(--border-color--primary)
        }
        ul.filter-menu li a .secondary {
            color: var(--font-color--secondary);
            font-weight: 600;
        }
        ul.filter-menu li a .dot-separator.secondary {
            background-color: var(--border-color--secondary)
        }
        ul.filter-menu li a .terciary {
            color: var(--font-color--terciary);
            font-weight: 600;
        }
        ul.filter-menu li a .dot-separator.terciary {
            background-color: var(--border-color--terciary)
        }

        /* summary */

        .summary {
            display: flex;
            flex-direction: row;
            flex-shrink: 0;
            padding: 20px 20px;
            border-top: 1px solid var(--bg-color--8);

            .summary__item {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                padding: 0 20px;
                border-right: 1px solid var(--bg-color--8)
            }

            .summary__item.border-left {
                border-left: 1px solid var(--bg-color--8)
            }

            .summary__item:last-child {
                border-right: 0
            }
        }

        /* footer */

        div.footer {
            padding: 40px 0;
            display: flex;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
        }

        div.footer a {
            text-transform: uppercase;
        }

        div.footer span {
            font-weight: 600;
        }

        div.footer .left-side {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding-left: 20px;
        }

        div.footer .left-side > * {
            margin: 0 5px;
        }

        div.footer .right-side {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding-right: 20px;
        }

        div.footer .right-side .group {
            border: 1px solid var(--bg-color--9);
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0 15px;
            border-radius: 10px;
            margin-right: 10px;
            height: 32px;
        }

        div.footer .right-side > a {
            height: 30px;
        }

        div.footer .right-side .group .dot-separator {
            margin: 0 10px;
        }

        div.footer .right-side .group span {
            margin-right: 10px;
            white-space: nowrap
        }

        div.footer .right-side > * {
            margin: 0 5px;
        }

        div.footer .right-side > *:last-child {
            margin: 0 0 0 5px;
        }
    }
    .page--crud > div {
        width: 96%;
        text-align: center;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
    }
    .page--crud > div > h3 {
        padding-bottom: 30px;
    }

    .datetime-selector {
        margin-bottom: 0;
        border: 0;
        margin-top: 0;
        padding: 0;
        &:hover, &:active, &:focus {
            margin-bottom: 0;
            border: 0;
            margin-top: 0;
            padding: 0;
        }
    }

</style>